// extracted by mini-css-extract-plugin
module.exports = {"Youtube_Container":"YouTubeEmbed_Youtube_Container__wfzY_","Youtube_Video":"YouTubeEmbed_Youtube_Video__d-oO6"};